import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for agent list.
 * @extends JetView
 */
export default class tableAgentListView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Custom checkbox template for action column.
         * @param {Object} obj - The data object for the row.
         * @param {Object} common - Common properties.
         * @param {string} value - The value of the checkbox.
         * @returns {string} HTML string for the checkbox.
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'I')
                return ''; // Return empty if value is not 'I'
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>'; // Return HTML for approve/reject buttons
        }

        return {
            view: 'datatable', // DataTable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
            columns: [
                // Column definitions
                {
                    id: 'Action',
                    header: '',
                    template: custom_checkbox, // Use custom checkbox template
                    width: 100,
                },
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Detalles', // Tooltip for details column
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                    },
                },
                { id: 'Id', header: 'ID Usuario', width: 100, sort: 'int' }, // User ID column
                { id: 'Name', header: 'Nombre', width: 250, sort: 'int' }, // Name column
                { id: 'Email', header: 'Email', width: 250, sort: 'int' }, // Email column
                { id: 'Currency', header: 'Moneda', width: 250, sort: 'int' }, // Currency column
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'), // Localized header for creation date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text', // Sort by text
                    format: dateFormat, // Date format
                },
            ],
            onClick: {
                // Event handlers for click events
                details: function (euv, id) {
                    if (vthis.getUrl()[0].page !== 'customers')
                        vthis.show('customers?user=' + id + '/information'); // Show customer information
                    else vthis.show('information'); // Show general information
                },
                approbarbutton: function (ev, id) {
                    var item = this.getItem(id); // Get the clicked item
                    if (item.IsRegisterActivate == 'I') {
                        // Check if the item can be activated
                        const data = {
                            Id: item.Id,
                            Action: 'A', // Action to approve
                        };
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/SetStateValidate', // API endpoint
                                data,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error'); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse JSON response
                                        if (json.HasError) {
                                            webix.message({
                                                title: '¡Error!',
                                                type: 'alert-error',
                                                text: _(
                                                    'Ocurrio un error, comuniquese con soporte', // Error message
                                                ),
                                            });
                                        } else {
                                            item.IsRegisterActivate = 'A'; // Update item status
                                            item.Action = 'A'; // Update action
                                            webix.message('Saved'); // Show success message
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            title: '¡Error!',
                            type: 'alert-error',
                            text: 'No puedes activar un registro ya actualizado.', // Error message for already updated record
                        });
                    }
                },
                rechazarbutton: function (ev, id) {
                    var item = this.getItem(id); // Get the clicked item
                    if (item.IsRegisterActivate == 'I') {
                        // Check if the item can be rejected
                        const data = {
                            Id: item.Id,
                            Action: 'R', // Action to reject
                        };
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/SetStateValidate', // API endpoint
                                data,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error'); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse JSON response
                                        if (json.HasError) {
                                            webix.message({
                                                title: '¡Error!',
                                                type: 'alert-error',
                                                text: _(
                                                    'Ocurrio un error, comuniquese con soporte', // Error message
                                                ),
                                            });
                                        } else {
                                            item.IsRegisterActivate = 'I'; // Update item status
                                            item.Action = 'I'; // Update action
                                            webix.message('Saved'); // Show success message
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            title: '¡Error!',
                            type: 'alert-error',
                            text: 'No puedes activar un registro ya actualizado.', // Error message for already updated record
                        });
                    }
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/Client/GetClients', // Data source URL
            on: {
                // Event handlers for datatable events
                onItemDblClick: (id) => {
                    if (this.getUrl()[0].page !== 'customers')
                        this.show('customers?user=' + id + '/information'); // Show customer information on double click
                    else this.show('information'); // Show general information
                },
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Get the data URL
        this.on(this.app, 'playersList:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                // Check if editing the Action column
                var options = this.getColumnConfig('Action').collection; // Get options for Action column
                if (item.IsRegisterActivate != 'I') {
                    // Check if the item can be edited
                    console.log(item);
                    return false; // Prevent editing if not eligible
                }
                console.log(id);
            }
        });
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player ID
            );
        });
    }
}

// FILE DOCUMENTED
